import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Link } from "../directives/link";
import { TitleChange } from '../services/title-change';

@Component({
  selector: 'app-prophecies',
  imports: [Link],
  templateUrl: './prophecies.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './prophecies.scss',
})
export class Prophecies {
  dynamicTitle = inject(TitleChange);

  constructor() {
    this.dynamicTitle.title(`Prophecies`);
    this.dynamicTitle.description(`Jesus didn't fulfill any prophecies. The list of 300+ is complete nonsense.`);
  }
}
